import Login from './login.vue'

export default {
  name: 'login',
  path: '/accounts/login',
  component: Login,
  meta: {
    secure: false,
    reCaptcha: true
  }
}